import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Star, Camera, CheckCircle2 } from 'lucide-react';
import { useNavigation } from '../context/NavigationContext';
import { useApp } from '../context/AppContext';
import { Screen } from '../types';
import { Header } from '../components/ui/Header';
import { Button } from '../components/ui/Button';
export function WriteReviewScreen() {
  const {
    currentParams,
    goBack
  } = useNavigation();
  const {
    orders
  } = useApp();
  const orderId = currentParams?.orderId;
  const order = orders.find(o => o.id === orderId) || orders[0];
  const [ratings, setRatings] = useState<Record<string, number>>({});
  const [reviews, setReviews] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  if (!order) return null;
  const handleRating = (productId: string, rating: number) => {
    setRatings(prev => ({
      ...prev,
      [productId]: rating
    }));
  };
  const handleReviewChange = (productId: string, text: string) => {
    setReviews(prev => ({
      ...prev,
      [productId]: text
    }));
  };
  const handleSubmit = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSuccess(true);
      setTimeout(() => {
        goBack();
      }, 1500);
    }, 1000);
  };
  if (success) {
    return <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} className="min-h-screen bg-white flex flex-col items-center justify-center p-6 text-center" data-id="element-2725">
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 15
      }} className="mb-6 text-success" data-id="element-2726">
          <CheckCircle2 className="w-24 h-24" data-id="element-2727" />
        </motion.div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-2728">
          Reviews Submitted!
        </h1>
        <p className="text-gray-500" data-id="element-2729">Thank you for sharing your feedback.</p>
      </motion.div>;
  }
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="min-h-screen bg-gray-50 pb-24" data-id="element-2730">
      <Header title="Write a Review" data-id="element-2731" />

      <div className="p-4 space-y-4" data-id="element-2732">
        {order.items.map(item => <div key={item.id} className="bg-white p-4 rounded-2xl shadow-sm border border-gray-50" data-id="element-2733">
            <div className="flex gap-3 mb-4 pb-4 border-b border-gray-50" data-id="element-2734">
              <div className="w-16 h-16 rounded-xl overflow-hidden bg-gray-100 shrink-0" data-id="element-2735">
                <img src={item.product.image} alt={item.product.name} className="w-full h-full object-cover" data-id="element-2736" />
              </div>
              <div data-id="element-2737">
                <h3 className="text-sm font-medium text-gray-900 line-clamp-2 mb-1" data-id="element-2738">
                  {item.product.name}
                </h3>
                <p className="text-sm font-bold text-primary" data-id="element-2739">
                  ₦{item.product.price.toLocaleString()}
                </p>
              </div>
            </div>

            <div className="mb-4" data-id="element-2740">
              <p className="text-sm font-medium text-gray-900 mb-2 text-center" data-id="element-2741">
                How would you rate this product?
              </p>
              <div className="flex justify-center gap-2" data-id="element-2742">
                {[1, 2, 3, 4, 5].map(star => <button key={star} onClick={() => handleRating(item.id, star)} className="p-1 active:scale-90 transition-transform" data-id="element-2743">
                    <Star className={`w-8 h-8 ${(ratings[item.id] || 0) >= star ? 'fill-accent text-accent' : 'fill-gray-100 text-gray-200'}`} data-id="element-2744" />
                  </button>)}
              </div>
            </div>

            <div className="mb-4" data-id="element-2745">
              <textarea placeholder="What did you like or dislike? What did you use this product for?" value={reviews[item.id] || ''} onChange={e => handleReviewChange(item.id, e.target.value)} className="w-full bg-gray-50 border border-gray-200 rounded-xl p-3 text-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary resize-none h-24" data-id="element-2746" />
            </div>

            <button className="w-full flex items-center justify-center gap-2 py-3 border-2 border-dashed border-gray-200 rounded-xl text-gray-500 hover:bg-gray-50 hover:border-primary hover:text-primary transition-colors" data-id="element-2747">
              <Camera className="w-5 h-5" data-id="element-2748" />
              <span className="text-sm font-medium" data-id="element-2749">Add Photos</span>
            </button>
          </div>)}
      </div>

      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 p-4 pb-safe z-40" data-id="element-2750">
        <div className="max-w-md mx-auto" data-id="element-2751">
          <Button fullWidth onClick={handleSubmit} loading={loading} disabled={Object.keys(ratings).length === 0} data-id="element-2752">
            Submit Reviews
          </Button>
        </div>
      </div>
    </motion.div>;
}